
export const productionOrderStates = { "RUNNING": "Running", "PAUSED": "Paused", "STOPPED": "Stopped", "PLANNED": "Planned", "DONE": "Done" }

